import { Column } from "@material-table/core";

import { Ecr } from "api/memberPortal/ecr/ecr.types";
import { Maintenance } from "api/memberPortal/project/maintenance/maintenance.types";

import EcrActionsCell from "./cells/EcrActions.cell";
import EcrDocumentTypeCell from "./cells/EcrDocumentType.cell";
import EcrIdCell from "./cells/EcrId.cell";
import EcrVidCell from "./cells/EcrVid.cell";

interface BuildEcrCommentsTableColumnsProps {
  setEcr?: (_ecr: Ecr) => void;
  setEcrToDelete?: (_ecr: Ecr) => void;
  setIsEditing?: (_isEditing: boolean) => void;
  setShowCommentForm: (_showCommentForm: boolean) => void;
  setShowDeleteModal?: (_showDeleteModal: boolean) => void;
  maintenance?: Maintenance;
  vidNumber?: string | number;
}

const buildEcrCommentsTableColumns = ({
  setEcr,
  setIsEditing,
  setShowCommentForm,
  setShowDeleteModal,
  setEcrToDelete,
  maintenance,
  vidNumber,
}: BuildEcrCommentsTableColumnsProps): Column<Ecr>[] => [
  {
    title: "ID",
    field: "ecrid",
    headerStyle: { position: "sticky", left: 0, zIndex: 99 },
    cellStyle: { position: "sticky", left: 0 },
    render: (rowData) => <EcrIdCell ecrid={rowData.ecrid} />,
  },
  {
    title: "VID",
    field: "pid.v_id",
    hidden: Boolean(maintenance),
    render: (rowData) => <EcrVidCell ecr={rowData} />,
  },
  {
    title: "AM",
    field: "maintenance_id.maintenance_id",
    hidden: Boolean(vidNumber),
    render: (rowData) => <span>{rowData.maintenance_id?.maintenance_id}</span>,
  },
  {
    title: "Author",
    field: "creator",
    render: (rowData) => (
      <span>
        {rowData.creator?.first_name} {rowData.creator?.last_name}
      </span>
    ),
  },
  { title: "Type", field: "type" },
  { title: "Status", field: "status" },
  {
    title: "Relates To",
    field: "process_location",
    hidden: true,
    hiddenByColumnsButton: true,
  },
  {
    title: "Document Type",
    render: (rowData) => <EcrDocumentTypeCell ecrid={rowData.ecrid} />,
    sorting: false,
  },
  {
    title: "Comment Title",
    field: "gist",
  },
  { title: "Requirement", field: "req" },
  { title: "Added", field: "entrydate", type: "date" },
  { title: "Modified", field: "moddate", type: "date" },
  {
    title: "Actions",
    field: "actions",
    filtering: false,
    sorting: false,
    headerStyle: {
      position: "sticky",
      right: "0",
      textAlign: "center",
      background: "white",
    },
    cellStyle: {
      padding: 0,
      position: "sticky",
      right: "0",
      background: "white",
      textAlign: "center",
    },
    render: (rowData) => (
      <EcrActionsCell
        ecr={rowData}
        setEcr={setEcr}
        setIsEditing={setIsEditing}
        setShowCommentForm={setShowCommentForm}
        setShowDeleteModal={setShowDeleteModal}
        setEcrToDelete={setEcrToDelete}
      />
    ),
  },
];
export default buildEcrCommentsTableColumns;
